<script>
import InputPhone from '@/components/atoms/inputlib/components/InputPhone'
import FormValidation from '@/components/atoms/FormValidation'

export default {
    name: 'Step4',
    components: {
        InputPhone,
        FormValidation,
    },
    model: {
        prop: 'address',
        event: 'change',
    },
    props: {
        address: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        addressValue: {
            get() {
                return this.address
            },
            set(address) {
                this.$emit('change', address)
            },
        },
    },
    methods: {
        verifyStep() {
            this.$refs.form.formSubmit()
        },
        next() {
            this.$emit('next', 0)
        },
    },
}
</script>
<template lang="pug">
form-validation(@submit="next" ref="form")
    input-phone(
        v-model="addressValue.phone"
        type="phone"
        validate="phone"
        live required) {{$t('details.phone')}}
    span {{ $t('details.phone_info') }}
</template>
